export default __webpack_public_path__ + "static/media/mystore.ae190405.png";